// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__sLAFA","row":"styles_row__3aPEA"};